const SUBSCRIPTION_PRODUCT_TYPE = 'magazine_subscription';
const MAGAZINE_SINGLE_ISSUE_PRODUCT_TYPE = 'magazine_single_issue';
const SUBSCRIPTION_TYPE_OPTION_LABEL = 'Subscription Type';
const REGION_OPTION_LABEL = 'Region';
const PRODUCT_VARIANTS_CLASSNAME = 'kel-shopware-product-variants';
const PRODUCT_VARIANTS_ANCHOR_ID = 'product-variants';
const OFFER_PARAM = 'offer';
const CAMPAIGN_CODE_FIELD = 'darwin_alt_campaign_code';
const OFFER_OPTION_LABEL = 'Offer';
const STANDARD_OFFER_VALUE = 'STANDARD';
const AFTER_CHRISTMAS_TOGGLE_LABEL = 'This is a gift to start after Christmas';

export {
  SUBSCRIPTION_PRODUCT_TYPE,
  MAGAZINE_SINGLE_ISSUE_PRODUCT_TYPE,
  SUBSCRIPTION_TYPE_OPTION_LABEL,
  REGION_OPTION_LABEL,
  PRODUCT_VARIANTS_CLASSNAME,
  PRODUCT_VARIANTS_ANCHOR_ID,
  OFFER_PARAM,
  CAMPAIGN_CODE_FIELD,
  OFFER_OPTION_LABEL,
  STANDARD_OFFER_VALUE,
  AFTER_CHRISTMAS_TOGGLE_LABEL
};
